import { ErrorBoundary } from "@sentry/react";
import type { ReactNode } from "react";
import { Result } from "antd";
import { useTranslation } from "react-i18next";

// Top-level crash boundary. Sentry.ErrorBoundary reports the render error (a
// no-op when Sentry is disabled — see src/sentry.ts) and swaps in a fallback,
// so a component crash degrades to a message inside the embed instead of a
// blank iframe. Rendered once around <App/> in main.tsx.
function Fallback() {
  const { t } = useTranslation();
  return (
    <Result
      status="warning"
      title={t("team.errorBoundary.title")}
      subTitle={t("team.errorBoundary.subtitle")}
    />
  );
}

export function AppErrorBoundary({ children }: { children: ReactNode }) {
  return <ErrorBoundary fallback={<Fallback />}>{children}</ErrorBoundary>;
}
